"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.CampaignMonitorLogo = props => {
    return (react_1.default.createElement("svg", Object.assign({ viewBox: "0 0 256 175", preserveAspectRatio: "xMidYMid" }, props),
        react_1.default.createElement("path", { d: "M254.23 5.119c-3.089-4.4-9.152-5.478-13.564-2.384L1.753 170.019c1.759 2.504 4.667 4.154 7.966 4.148l.012.006v-.006h236.528c5.376 0 9.735-4.359 9.735-9.742V10.55a9.714 9.714 0 0 0-1.764-5.431M15.328 2.728C10.922-.362 4.853.71 1.764 5.11A9.733 9.733 0 0 0 0 10.548l.006 154.171 113.742-93.176-98.42-68.815", fill: "#2A2E32" })));
};
//# sourceMappingURL=CampaignMonitorLogo.js.map